import React, { createContext, useContext } from "react";

const AIAssistantContext = createContext(null);

export function useAIAssistant() {
  const ctx = useContext(AIAssistantContext);
  return ctx || { openAssistant: () => {}, closeAssistant: () => {} };
}

export function AIAssistantProvider({ children, openAssistant, closeAssistant }) {
  const value = React.useMemo(
    () => ({ openAssistant: openAssistant || (() => {}), closeAssistant: closeAssistant || (() => {}) }),
    [openAssistant, closeAssistant]
  );
  return (
    <AIAssistantContext.Provider value={value}>
      {children}
    </AIAssistantContext.Provider>
  );
}
